import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { ApiProject } from "@/hooks/use-projects";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PlatformIcon } from "@/components/ui/platform-icon";

export function ProjectCard({ project }: { project: ApiProject }) {
  const { t } = useTranslation("projects");
  const params = useParams<{ brandSlug: string }>();
  const brandSlug = params.brandSlug!;

  return (
    <Link to={`/${brandSlug}/projects/${project.id}`}>
      <Card className="transition-colors hover:border-foreground/20 cursor-pointer">
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <CardTitle className="text-base">{project.title}</CardTitle>
            <Badge variant="outline" className="text-xs capitalize">
              {t(`projects:pipelineStage.${project.pipelineStage}`)}
            </Badge>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground line-clamp-2">{project.brief}</p>
          <div className="mt-3 flex items-center gap-2">
            {project.targetPlatforms.map((p) => (
              <PlatformIcon key={p} platform={p} size={14} />
            ))}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
